import { LeftPane, RightPane, Wrapper } from "../TopBar/elements";
import View from "../View";

export default function TopBarPlaceholder() {
    return (
        <Wrapper>
            <View width="100%" justify="space-between" className="main-toolbar">
                <LeftPane />
                <RightPane />
            </View>
        </Wrapper>
    );
}
